import { CardContent, Grid } from '@mui/material';

import { Divider, InfoField } from '@occc-app/design-system';
import { RetailerNetworkFragment } from '@occc/graphql';
import { PageSection } from '@occc/ui-design-system';
import { formatPhoneNumberNationalForUS } from '@occc/utils-phone-number';
import { formatFullAddress } from '@occc/utils-formatters';

type RetailerNetworkDetailsSectionProps = {
  retailerNetwork: RetailerNetworkFragment;
};

export const RetailerNetworkDetailsSection = ({
  retailerNetwork,
}: RetailerNetworkDetailsSectionProps) => (
  <PageSection title='Retailer Network Information'>
    <CardContent>
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <InfoField
            sx={{ m: 0 }}
            label='Network Name'
            value={retailerNetwork.name}
            noDataMessage=''
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <InfoField
            sx={{ m: 0 }}
            label='Network Display Name'
            value={retailerNetwork.displayName}
            noDataMessage=''
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <InfoField
            sx={{ m: 0 }}
            label='Network Contact'
            value={retailerNetwork.adminName}
            noDataMessage=''
          />
        </Grid>
      </Grid>
      <Divider sx={{ my: 3 }} />
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <InfoField
            sx={{ m: 0 }}
            label='Network Address'
            value={formatFullAddress(retailerNetwork.address)}
            noDataMessage=''
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <InfoField
            sx={{ m: 0 }}
            label='Network Phone Number'
            value={formatPhoneNumberNationalForUS(retailerNetwork.phoneNumber)}
            noDataMessage=''
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <InfoField
            sx={{ m: 0 }}
            label='Network Email'
            value={retailerNetwork.emailAddress}
            noDataMessage=''
          />
        </Grid>
      </Grid>
    </CardContent>
  </PageSection>
);
